export const EVENT_BOOKINGS_RESET_STATE = 'EVENT_BOOKINGS_RESET_STATE';
export const EVENT_BOOKINGS_CURRENT_ITEM = 'EVENT_BOOKINGS_CURRENT_ITEM';

export const EVENT_BOOKINGS_REQUEST_LOADING = 'EVENT_BOOKINGS_REQUEST_LOADING';
export const EVENT_BOOKINGS_REQUEST_SUCCESS = 'EVENT_BOOKINGS_REQUEST_SUCCESS';
export const EVENT_BOOKINGS_REQUEST_FAILED = 'EVENT_BOOKINGS_REQUEST_FAILED';

export const EVENT_BOOKINGS_CURRENT_ACTION = 'EVENT_BOOKINGS_CURRENT_ACTION';
export const EVENT_BOOKINGS_RESET_ACTION = 'EVENT_BOOKINGS_RESET_ACTION';